module.exports = __webpack_public_path__ + "img/powered-by-light.02aa1180.svg";